import { DateTime as d } from "luxon";

export const LEAD_TIME_UNITS = ["HOURS", "DAYS", "MONTHS"] as const;
export type LeadTimeUnit = typeof LEAD_TIME_UNITS[number];

const SECONDS_IN_UNIT: Record<LeadTimeUnit, number> = {
  HOURS: 3600,
  DAYS: 86400,
  MONTHS: 2592000,
};

export interface ILeadTimeSettings {
  minLeadTimeOptIn?: boolean;
  minLeadTimeValue?: number;
  minLeadTimeUnit?: string;
  maxLeadTimeOptIn?: boolean;
  maxLeadTimeValue?: number;
  maxLeadTimeUnit?: string;
}

export const getLeadTimeInSeconds = (value?: number, unit?: string) => {
  if (!value || !unit) {
    return 0;
  }

  const multiplier = SECONDS_IN_UNIT[unit as LeadTimeUnit];
  if (!multiplier) {
    return 0;
  }

  return value * multiplier;
};

export const getMinPickupDateTime = (settings?: ILeadTimeSettings, timeZone?: string) => {
  const leadTimeSeconds = getLeadTimeInSeconds(
    settings?.minLeadTimeValue,
    settings?.minLeadTimeUnit
  );
  const now = d.now().setZone(timeZone || "Europe/London");

  if (settings?.minLeadTimeOptIn && leadTimeSeconds) {
    return now.plus({ seconds: leadTimeSeconds });
  }

  return now;
};

export const getMaxPickupDateTime = (settings?: ILeadTimeSettings, timeZone?: string) => {
  const leadTimeSeconds = getLeadTimeInSeconds(
    settings?.maxLeadTimeValue,
    settings?.maxLeadTimeUnit
  );

  if (settings?.maxLeadTimeOptIn && leadTimeSeconds) {
    return d.now().setZone(timeZone || "Europe/London").plus({ seconds: leadTimeSeconds });
  }

  return null;
};

export const isPickupWithinLeadTime = (
  pickupDateTime: string,
  settings?: ILeadTimeSettings,
  timeZone?: string
) => {
  const pickup = d.fromISO(pickupDateTime);
  const minPickup = getMinPickupDateTime(settings, timeZone);
  const maxPickup = getMaxPickupDateTime(settings, timeZone);

  if (pickup < minPickup) {
    return false;
  }

  if (maxPickup && pickup > maxPickup) {
    return false;
  }

  return true;
};
